import http from '@/services/http';

export async function downloadFile(url: string, filename: string) {
  return http({
    url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });
}

export default downloadFile;